var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Dokument löschen","action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('span',[_vm._v("Dokument wirklich löschen? Dies kann nicht rückgängig gemacht werden!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }